import app, { vuwer, u_, csl } from "@@assets/scripts/common";
import "@@assets/scripts/jquery.initFbPagePlugin";


vuwer.add("fbArea", {
	selector: "#fb_area",
	
	initPlugin(height) {
		const { $self } = this;
		csl.log.blue("** fb page init", { $self, height });
		if(!$self) {
			return false;
		}
		
		const $fbPage = $self.children(".fb-page");
		if(!$fbPage.length) {
			return false;
		}
		
		const href = $fbPage.attr("data-href");
		const title = $fbPage.attr("data-title") || "";
		if(!href) {
			return false;
		}
		
		if(!u_.isNumber(height) || height < 500 || app.device[0] === "sp") {
			height = 500;
		}
		
		let width = $self.width();
		if(width > 500) {
			width = 500;
		}
		
		$fbPage.initFbPagePlugin({
			href,
			height,
			width,
			"tabs": "timeline",
			"small-header": false,
			"adapt-container-width": true,
			"hide-cover": false,
			"show-facepile": false
		}, title, "9.0");
	},
	
	onChangeState(state) {
		if( u_.isNumber(state.h) && state.h !== this.state.h) {
			return this.initPlugin( Math.floor(state.h) );
		}
	}
});
